

import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    {
        const PAGEA = document.querySelector('.RecipeHolderPage')
        const PAGEB = document.querySelector('.ArticleHolderPage')

        if(!PAGEA && !PAGEB) return

        let PAGE = PAGEA

        if(!PAGEA) PAGE = PAGEB

        const items = PAGE.querySelectorAll('.link-card')

        const timeline = gsap.timeline({
            ease: 'power2.inOut'
        })

        timeline.to(items, {
                stagger: 0.1,
                opacity: 1,
            })
    }
}
